export default __webpack_public_path__ + "static/media/popover-triangle.2adab342.svg";